"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToday = void 0;
const dateFormat_1 = require("./dateFormat");
/**
 * dzisiejsza data w formacie yyyy-MM-dd
 */
function dateToday() {
    return (0, dateFormat_1.dateFormat)(new Date());
}
exports.dateToday = dateToday;
//# sourceMappingURL=dateToday.js.map